import React, { useState } from 'react';
import SummaryCards from './SummaryCards';
import ComparisonTable from './ComparisonTable';
import BarrasTable from './BarrasTable';
import SaeDescripcion from './SaeDescripcion';

function Report({ report, onExportExcel, onExportPDF, onReset }) {
  const [activeTab, setActiveTab] = useState('all');

  const filteredResults = activeTab === 'all'
    ? report.results
    : report.results.filter(r => r.status === activeTab);

  const tabs = [
    { key: 'all', label: 'Todos', count: report.summary.total },
    { key: 'coincide', label: '✅ Coinciden', count: report.summary.coincide, color: 'text-green-600' },
    { key: 'no_coincide', label: '❌ No coinciden', count: report.summary.no_coincide, color: 'text-red-600' },
    { key: 'no_validable', label: '⚠️ Requiere revisión manual', count: report.summary.no_validable, color: 'text-yellow-600' },
    { key: 'fijo', label: 'ℹ️ Fijos', count: report.summary.fijo, color: 'text-blue-600' },
  ];

  return (
    <div className="space-y-6">
      {/* Actions bar */}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-xl font-bold text-gray-800">
            Resultado de Validación
          </h2>
          <p className="text-sm text-gray-500">
            Factura: <span className="font-mono font-semibold">{report.facturaExpData?.numero || report.factura || 'N/A'}</span>
            {report.consecutivo && (
              <span> — Consecutivo: <span className="font-mono font-semibold">{report.consecutivo}</span></span>
            )}
          </p>
        </div>
        <div className="flex gap-2">
          <button
            onClick={onExportExcel}
            className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-semibold hover:bg-green-700 transition-colors shadow-sm flex items-center gap-1"
          >
            📊 Exportar Excel
          </button>
          <button
            onClick={onExportPDF}
            className="px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-semibold hover:bg-red-700 transition-colors shadow-sm flex items-center gap-1"
          >
            📄 Exportar PDF
          </button>
          <button
            onClick={onReset}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg text-sm font-semibold hover:bg-gray-300 transition-colors"
          >
            🔄 Nueva validación
          </button>
        </div>
      </div>

      {/* Summary cards */}
      <SummaryCards summary={report.summary} />

      {/* VB warning */}
      {!report.vbCargado && (
        <div className="bg-yellow-50 border border-yellow-300 rounded-lg p-4 flex items-start gap-3">
          <span className="text-2xl">⚠️</span>
          <div>
            <p className="font-semibold text-yellow-800">Visto Bueno no cargado</p>
            <p className="text-sm text-yellow-700 mt-1">
              No se pudieron validar los datos del Visto Bueno ANM: Número VB, Gramos finos de ORO,
              Gramos finos de PLATA, Gramos BRUTOS, Monto de Regalías.
            </p>
          </div>
        </div>
      )}

      {/* Tabs */}
      <div className="flex gap-1 bg-gray-100 p-1 rounded-xl overflow-x-auto">
        {tabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all
              ${activeTab === tab.key
                ? 'bg-white shadow-sm text-gold-700 font-semibold'
                : 'text-gray-500 hover:text-gray-700'
              }`}
          >
            {tab.label} <span className="ml-1 text-xs opacity-70">({tab.count})</span>
          </button>
        ))}
      </div>

      {/* Comparison table */}
      <ComparisonTable results={filteredResults} />

      {/* Barras detail */}
      {report.barras && report.barras.length > 0 && (
        <BarrasTable barras={report.barras} />
      )}

      {/* Descripcion SAE con coincidencias resaltadas */}
      {(report.saeDescripcion || report.saeSubpartida) && (
        <SaeDescripcion
          descripcion={report.saeDescripcion}
          subpartida={report.saeSubpartida}
          barras={report.barras}
          factura={report.facturaExpData?.numero || report.factura}
          vbNumero={report.vbData?.numero || report.vbData?.numero_vb}
          vbTramite={report.vbData?.tramite}
          vbFechaExpedicion={report.vbData?.fecha_aprobacion}
          vbFechaVencimiento={report.vbData?.fecha_vencimiento}
        />
      )}
    </div>
  );
}

export default Report;
